import React, { Fragment } from 'react';
import HeaderTop from '../../components/HeaderTop/HeaderTop';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import Contactpage from '../../components/Contactpage/Contactpage';

import MapSection from '../../components/MapSection/MapSection';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Logo from '../../images/logo.svg';
import Footer from '../../components/footer/Footer';


const ContactPage = () => {
    return (
        <Fragment>
            <HeaderTop />
            <Navbar hclass={'wpo-site-header'} Logo={Logo} />
            <section className={`wpo-breadcumb-area`}>
                <PageTitle pageTitle={'International Logistics'} pagesub={'Contact Us'} />
            </section>
            <Contactpage />
            <MapSection />
            {/* <CtaSection hclass={'wpo-cta-section-s2'} /> */}
            <Footer hclass={'wpo-site-footer'} />
            <Scrollbar />
        </Fragment>
    )
};
export default ContactPage;





